export function siteBuilderPartOptionKey(
    part: string | null | undefined,
    key: string,
): string {
    if (!part || part === "root" || part.startsWith("slot:")) {
        return key;
    }

    const normalizedPart = part
        .split(/[:/.]/u)
        .filter(Boolean)
        .map((segment, index) => {
            const normalized = segment.replace(/[^a-zA-Z0-9]/gu, "");

            return index === 0
                ? normalized
                : normalized.replace(
                    /^./u,
                    (character) => character.toUpperCase(),
                );
        })
        .join("");

    return normalizedPart
        ? `${normalizedPart}${key.slice(0, 1).toUpperCase()}${key.slice(1)}`
        : key;
}
